import '../../style/index.less'
import './index.less'

// style dependencies
import '../../spin/style'
import '../../pagination/style'
import '../../grid/style'



// WEBPACK FOOTER //
// ./components/list/style/index.js